import { HOME_URL } from "../constants";

export const validateUnlocklabUrl = url => {
  const domain = HOME_URL?.replace(/^https?:\/\//, "")?.toLowerCase();
  return url.includes(domain);
};
